export default "__VITE_ASSET__ffe05ff5__"